import Event from "../components/event";


function Events() {
  return (
    <div className="Events">
      <Event/>
    </div>
  );
}

export default Events;
